import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Sidebar.css';

interface MenuItem {
  path: string;
  label: string;
  icon?: string;
  customIcon?: React.ReactNode;
}

const PawIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6-4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM6 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm3.5-4C8.4 2 7.5 2.9 7.5 4s.9 2 2 2 2-.9 2-2-.9-2-2-2zm5 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM12 16c-2.2 0-4 1.8-4 4 0 .6.5 1 1 1h6c.6 0 1-.4 1-1 0-2.2-1.8-4-4-4z"/>
  </svg>
);

const menuItems: MenuItem[] = [
  { path: '/', label: 'Dashboard', icon: 'bi-grid' },
  { path: '/animals', label: 'Buscar Animais', customIcon: <PawIcon /> },
  { path: '/missing-animals', label: 'Animais Desaparecidos', icon: 'bi-heartbreak' },
  { path: '/transfers', label: 'Transferências', icon: 'bi-arrow-left-right' },
  { path: '/news', label: 'Notícias', icon: 'bi-newspaper' },
];

interface SidebarProps {
  mobileOpen?: boolean;
  onMobileClose?: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ mobileOpen = false, onMobileClose }) => {
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);

  return (
    <>
      {mobileOpen && (
        <div
          className="sidebar-overlay"
          onClick={onMobileClose}
          onKeyDown={(e) => e.key === 'Escape' && onMobileClose?.()}
          role="button"
          tabIndex={0}
          aria-label="Fechar menu"
        />
      )}
      <div className={`metronic-sidebar ${collapsed ? 'sidebar-collapsed' : ''} ${mobileOpen ? 'sidebar-mobile-visible' : ''}`} id="kt_app_sidebar">
      <div className="sidebar-logo">
        <Link to="/" className="sidebar-logo-link">
          <span className="sidebar-logo-icon">
            <i className="bi bi-heart-pulse" />
          </span>
          {!collapsed && <span className="sidebar-logo-text">PetID Brasil</span>}
        </Link>
        <button
          type="button"
          className="sidebar-toggle"
          onClick={() => setCollapsed(!collapsed)}
          aria-label={collapsed ? 'Expandir menu' : 'Recolher menu'}
        >
          <i className={`bi ${collapsed ? 'bi-chevron-right' : 'bi-chevron-left'}`} />
        </button>
      </div>
      <div className="sidebar-menu">
        <ul className="sidebar-menu-nav">
          {menuItems.map((item) => {
            const isActive =
              location.pathname === item.path ||
              (item.path !== '/' &&
                item.path !== '/animals' &&
                location.pathname.startsWith(item.path)) ||
              (item.path === '/animals' &&
                (location.pathname === '/animals' || (location.pathname.startsWith('/animals/') && location.pathname !== '/animals/deceased')));
            return (
              <li key={item.path} className="sidebar-menu-item">
                <Link
                  to={item.path}
                  className={`sidebar-menu-link ${isActive ? 'active' : ''}`}
                  onClick={() => onMobileClose?.()}
                >
                  {(item.icon || item.customIcon) && (
                    <span className="sidebar-menu-icon">
                      {item.customIcon ? item.customIcon : <i className={`bi ${item.icon}`} />}
                    </span>
                  )}
                  {!collapsed && <span className="sidebar-menu-title">{item.label}</span>}
                </Link>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
    </>
  );
};

export default Sidebar;
